import { useState, createContext, useEffect } from 'react'

import { useSelector } from 'react-redux'
import { isFunction } from 'lodash'

import ChatRooms from '../Components/shared/ChatRooms/ChatRooms'
import { selectUser } from '../reducers/UserReducer'
import { isObject } from '../utils'
import { selectTranslate } from '../reducers/LocaleReducer/LocalReducer'
import { addChatRoomToShift, getShiftChatRooms } from '../utils/api/shift'
import { CHAT_ROOM_TYPES, ChatRoom } from '../utils/entities/chatRoom'
import { HttpStatuses } from '../utils/http'

export const ScheduleChatRoomsContext = createContext()

const ScheduleChatRooms = ({ children, onOpen }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [handler, setHandler] = useState({ shift: null, callback: null })
  const [chatRooms, setChatRooms] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (handler.shift && isObject(user)) {
      setLoading(true)

      getShiftChatRooms(user, handler.shift).then(({ data }) => {
        setChatRooms(data)
      }).finally(() => {
        setLoading(false)
      })
    } else {
      setChatRooms([])
    }
  }, [user?.id, handler.shift])

  useEffect(() => {
    if (isFunction(onOpen) && handler.shift) {
      onOpen(handler.shift)
    }
  }, [onOpen, handler.shift])

  const handleCreateChatRoom = () => {
    return addChatRoomToShift(user, handler.shift, new ChatRoom({ type: CHAT_ROOM_TYPES.SCHEDULE })).then(({ data }) => {
      setChatRooms(prevChatRooms => ([...prevChatRooms, data]))
      return data
    }).catch(error => {
      if (error.status === HttpStatuses.CONFLICT) {
        setHandler({ ...handler })
        error = { status: HttpStatuses.CONFLICT, type: 'RELOAD_REQUIRED' }
      } else {
        console.error('Error while creating chat room for shift:', error)
      }

      return Promise.reject(error)
    })
  }

  const handleClose = () => {
    if (isFunction(handler.callback)) {
      handler.callback(chatRooms)
    }

    setHandler({ shift: null, callback: null })
  }

  return (
    <>
      <ScheduleChatRoomsContext.Provider value={{ setHandler }}>
        {children}
      </ScheduleChatRoomsContext.Provider>
      {handler?.shift && (
        <ChatRooms
          loading={loading}
          chatRooms={chatRooms}
          title={t('schedules_chat_rooms.title')}
          onClose={handleClose}
          onChatRoomCreate={handleCreateChatRoom}
          onSendMessage
          onUnread
          onFind
        />
      )}
    </>
  )
}

export default ScheduleChatRooms
